import Fallback from './Dashboard.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./Dashboard.page'),
});
